import axios from "axios";
import { SETTINGS } from "../../Settings";

export const TaskCountRepository = {
  fetchInstTaskCounts: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/taskCount`,
      method: "GET",
    });
  },
};
